export default {
    root: {
        class: [
            // Flex & Alignment
            'flex items-center justify-center flex-wrap',

            // Spacing
            'px-4 py-2',

            // Shape
            'border-0 rounded-md',

            // Color
            'bg-transparent',
            'text-surface-700 dark:text-white/60',

            'text-sm',
        ],
    },
    content: {
        class: ['flex items-center justify-center'],
    },
    first: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border border-r-0 border-neutral-300 rounded-l-md',

            // Size
            'min-w-[2.5rem] h-10',
            'leading-none',

            // Color
            'bg-white text-surface-500 dark:text-white/60',

            // State
            {
                'hover:bg-surface-200 dark:hover:bg-[rgba(255,255,255,0.06)]': !context.disabled,
                'focus:outline-none focus:outline-offset-0': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'user-none overflow-hidden',
            { 'cursor-not-allowed': context.disabled },
        ],
    }),
    prev: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border border-r-0 border-neutral-300',

            // Size
            'min-w-[2.5rem] h-10',
            'leading-none',

            // Color
            'bg-white text-surface-500 dark:text-white/60',

            // State
            {
                'hover:bg-surface-200 dark:hover:bg-[rgba(255,255,255,0.06)]': !context.disabled,
                'focus:outline-none focus:outline-offset-0': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'user-none overflow-hidden',
            { 'cursor-not-allowed': context.disabled },
        ],
    }),
    next: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border border-r-0 border-neutral-300',

            // Size
            'min-w-[2.5rem] h-10',
            'leading-none',

            // Color
            'bg-white text-surface-500 dark:text-white/60',

            // State
            {
                'hover:bg-surface-200 dark:hover:bg-[rgba(255,255,255,0.06)]': !context.disabled,
                'focus:outline-none focus:outline-offset-0': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'user-none overflow-hidden',
            { 'cursor-not-allowed': context.disabled },
        ],
    }),
    last: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border border-neutral-300',

            // Size
            'min-w-[2.5rem] h-10',
            'leading-none',

            // Color
            'bg-white text-surface-500 dark:text-white/60',

            // State
            {
                'hover:bg-surface-200 dark:hover:bg-[rgba(255,255,255,0.06)]': !context.disabled,
                'focus:outline-none focus:outline-offset-0': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'user-none overflow-hidden',
            { 'cursor-not-allowed': context.disabled },
        ],
    }),
    page: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border border-r-0 border-neutral-300',

            // Size
            'min-w-[2.5rem] h-10',
            'leading-none',

            'font-medium',

            // Color
            {
                'bg-primary-700 text-white': context.active,
                'bg-white text-surface-700 dark:text-white/60': !context.active,
            },

            // State
            {
                'hover:bg-surface-200 dark:hover:bg-[rgba(255,255,255,0.06)]': !context.disabled,
                'hover:!bg-primary-700 dark:hover:!bg-primary-700': context.active,
                'focus:outline-none focus:outline-offset-0': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'user-none overflow-hidden',
            { 'cursor-not-allowed': context.disabled },
        ],
    }),
    contentStart: 'mr-auto',
    contentEnd: 'ml-auto',
};
